// @flow
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Pill, pillColours } from 'moods-react/Pill';
import { Button, buttonTypes } from 'moods-react/Button';
import classnames from 'classnames';
import messages from '../../../data/accessories';

import './CustomisableMessage.scss';
import IframeDialogComponent from '../../common/dialog/iframe/IframeDialogComponent';
import AnalyticsClient from '../../../clients/AnalyticsClient';
import accessoriesEvents from '../../../analytics/events/accessories';

type Props = {
  desktop: boolean,
  mobile: boolean,
  formUrl: string,
  email: string,
  productName: string,
  openCustomiseRequestForm: Function,
  closeCustomiseRequestForm: Function,
  intl: Object,
};

const CustomisableMessage = (props: Props) => {
  const {
    desktop,
    mobile,
    formUrl,
    email,
    productName,
    openCustomiseRequestForm,
    closeCustomiseRequestForm,
    intl,
  } = props;

  const classNames = classnames('customisable-message', {
    'customisable-message--desktop': desktop,
    'customisable-message--mobile': mobile,
  });

  const closeOverlay = () => {
    closeCustomiseRequestForm();
  };

  const handleClick = () => {
    const dialog = (
      <IframeDialogComponent
        title={intl.formatMessage(messages.customisableFormDialogTitle)}
        submitCallback={() => {
          AnalyticsClient.trackEvent(accessoriesEvents.accessoryCustomiseRequest(productName));
        }}
        cancelText={intl.formatMessage(messages.customisableFormDialogCancelBtn)}
        okText={intl.formatMessage(messages.customisableFormDialogSubmitBtn)}
        successText={intl.formatMessage(messages.customisableFormDialogSuccess)}
        failureText={intl.formatMessage(messages.customisableFormDialogFailure)}
        closeOverlay={closeOverlay}
        formUrl={formUrl}
        email={email}
      />
    );
    openCustomiseRequestForm({
      content: dialog,
    });
  };

  return (
    <div className={classNames} data-customisable-message>
      <Pill colour={pillColours.BLUEBERGINE}>
        <FormattedMessage {...messages.customisablePillText} />
      </Pill>
      <div className="customisable-message__text">
        <FormattedMessage {...messages.customisableMessageText} />
      </div>
      <Button type={buttonTypes.STANDALONE_WHITE} data-customisable-form-button onClick={handleClick}>
        <FormattedMessage {...messages.customisableButtonText} />
      </Button>
    </div>
  );
};

export default injectIntl(CustomisableMessage);
